/** @format */
/** @format */

import React, { useState, useEffect } from "react";
import { FormatDate, LastMonth, LastWeekDate } from "components/FormatDate";
import SearchDate from "components/search/SearchDate";
import SearchTable from "components/search/SearchTable";
// Table
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

/* columns 관련 라이브러리 */
import Modal from "react-awesome-modal";
import { BasicAlert } from "components/Alert";
import TextField from "@material-ui/core/TextField";
import useSettings from "stores/settings";
import { projectFirestore } from "components/ProjectFirestore";

const headerSortingStyle = { backgroundColor: "#ddd" };

const ChargeList = () => {
  const settings = useSettings();
  /* 날짜로 검색 */
  const [startDate, setStartDate] = useState(LastMonth(new Date()));
  const [endDate, setEndDate] = useState(new Date());

  /* 데이터 업데이트 */
  const [updateData, setUpdateData] = useState(true);

  /* 결제 데이터 저장 */
  const [datas, setDatas] = useState([]);
  useEffect(async () => {
    if (settings.email) {
      const query = `SELECT * FROM creditCharge where buyerEmail = "${settings.email}" order by createdAt desc`;

      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ query }),
      };
      // const jsonData = await fetch(`${process.env.PUBLIC_URL}/api/aisoDatabaseFunction`, requestOptions);
      const jsonData = await fetch(process.env.GOOGLE_CLOUD_DATABASE_CONNECT_API, requestOptions);
      const result = await jsonData.json();

      if (result.msg) {
        setDatas(result.msg);
      } else {
        BasicAlert("error");
        return "";
      }
    }
  }, [updateData]);

  const columns = [
    {
      dataField: "id",
      text: "No",
      sort: true,
      headerSortingStyle,
      align: "center",
      headerAlign: "center",
      formatter: (cellContent, row, index) => {
        return <div>{index + 1}</div>;
      },
      style: {
        fontSize: "13px",
        color: "#888",
        minWidth: "60px",
        width: "70px",
      },
    },
    {
      dataField: "name",
      text: "충전명",
      sort: true,
      align: "right",
      headerAlign: "center",
      formatter: (cellContent) => {
        return (
          <div>
            <p className="mb-0 font-bold text-333 cell-nowrap">{cellContent}</p>
          </div>
        );
      },
      style: {
        minWidth: "100px",
        maxWidth: "100px",
      },
    },
    {
      dataField: "credit",
      text: "충전 크레딧",
      // text: "충전 크레딧 (Credit)",
      sort: true,
      align: "right",
      headerAlign: "center",
      formatter: (cellContent) => {
        return (
          <div>
            <p className="mb-0 font-bold text-333 cell-nowrap">{cellContent}</p>
            <p className="mb-0 text-ss text-555">Credit</p>
          </div>
        );
      },
      style: {
        minWidth: "50px",
        maxWidth: "50px",
      },
    },
    {
      dataField: "paidAmount",
      text: "충전 금액 (원)",
      sort: true,
      align: "right",
      headerAlign: "center",
      formatter: (cellContent) => {
        return (
          <div>
            <p className="mb-0 font-bold text-333 cell-nowrap">{cellContent}</p>
            <p className="mb-0 text-ss text-555">원</p>
          </div>
        );
      },
      style: {
        minWidth: "110px",
        maxWidth: "110px",
      },
    },
    {
      dataField: "status",
      text: "상태",
      sort: true,
      align: "right",
      headerAlign: "center",
      formatter: (cellContent) => {
        return (
          <div>
            {cellContent === "paid" && <p className="mb-0 font-bold text-333 cell-nowrap">결제 완료</p>}
            {cellContent === "cancelled" && <p className="mb-0 font-bold text-danger cell-nowrap">결제 취소</p>}
            {cellContent === "cancelRequest" && <p className="mb-0 font-bold text-danger cell-nowrap">결제 취소 요청</p>}
          </div>
        );
      },
      style: {
        minWidth: "110px",
        maxWidth: "110px",
      },
    },
    {
      dataField: "createdAt",
      text: "충전일",
      sort: true,
      align: "right",
      headerAlign: "center",
      formatter: (cellContent) => {
        const split = cellContent.split(" ");
        return (
          <div className="m-0">
            <p className="text-xs font-bold text-555">{split[0]}</p>
            <p className="mb-0 text-xs text-555">{split[1]}</p>
          </div>
        );
      },
      style: {
        minWidth: "110px",
        maxWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "더보기",
      align: "center",
      headerAlign: "center",
      formatter: (cellContent, row) => {
        return <DetailContent row={row} updateData={updateData} setUpdateData={setUpdateData} />;
      },
      style: {
        minWidth: "50px",
      },
    },
  ];

  return (
    <div className="border-table">
      <ToolkitProvider keyField="id" bootstrap4 data={datas} columns={columns} search>
        {(props) => (
          <div className="px-3">
            {/* Search Area */}
            <div className="row flex items-center justify-between">
              <SearchTable props={props} size={"col-xl-6 mt-3"} />
              {/* 날짜 검색 */}
              <SearchDate
                size={"col-xl-6 mt-3 mt-xl-0"}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
            </div>
            {/* Table Area */}
            <div className="block sm:flex justify-between items-center mt-3">
              <h5 className="mb-3">
                충전 내역 <span className="font-bold text-333 text-primary ml-2">{datas ? datas.length : 0}</span>
              </h5>
              {/* <button type="button" className="btn btn-grayDanger btn-sm mb-3" onClick={() => setModalVisible(true)}>
                결제 취소
              </button> */}
            </div>
            <div>
              <PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  totalSize: datas ? datas.length : 0,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <div>
                    <BootstrapTable
                      keyField="id"
                      data={datas}
                      columns={columns}
                      noDataIndication=" "
                      {...paginationTableProps}
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                      classes="mytable-hover2 border-table"
                      rowClasses="mytable-hover-row2"
                    />
                    <div className="flex justify-between items-center w-full">
                      <PaginationListStandalone {...paginationProps} />
                      <div className="flex justify-end">
                        <PaginationTotalStandalone {...paginationProps} />
                      </div>
                    </div>
                  </div>
                )}
              </PaginationProvider>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

const DetailContent = ({ row, updateData, setUpdateData }) => {
  // 모달 값 저장
  const [modalVisible, setModalVisible] = useState(false);

  const [detailList1, setDetailList1] = useState([]);
  const [detailList2, setDetailList2] = useState([]);
  const [detailList3, setDetailList3] = useState([]);

  /* 모달 */
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [withdrawalModalVisible, setWithdrawalModalVisible] = useState(false);

  /* 결제 취소 사유 */
  const [paidCancelContent, setPaidCancelContent] = useState("");

  useEffect(() => {
    if (row) {
      const tempDetailList1 = [];
      tempDetailList1.push({ 이름: row.buyerName });
      tempDetailList1.push({ 이메일: row.buyerEmail });
      setDetailList1(tempDetailList1);

      const tempDetailList2 = [];
      tempDetailList2.push({ "결제 금액": `${row.paidAmount} 원` });
      tempDetailList2.push({ "크레딧 금액": `${row.credit} Credit` });
      tempDetailList2.push({ 가격: `${row.price} 원` });
      tempDetailList2.push({ 할인: `-${row.discount} 원` });
      setDetailList2(tempDetailList2);

      const tempDetailList3 = [];
      tempDetailList3.push({ "결제 수단": row.cardName });
      tempDetailList3.push({ 할부: row.cardQuota });
      setDetailList3(tempDetailList3);
    }
  }, [row]);

  const closeModal = () => {
    setModalVisible(false);
    setPaidCancelContent("");
  };

  const closeCancelModal = () => {
    setCancelModalVisible(false);
    setPaidCancelContent("");
  };

  const handleModalOkButton = () => {
    setModalVisible(false);
    setPaidCancelContent("");
  };

  /* 결제 취소 모달 확인 버튼 클릭 시 실행 함수 */
  const handleCancelModalOkButton = async () => {
    if (!paidCancelContent || paidCancelContent === "") {
      const text = "결제 취소 사유를 입력해주세요.";
      BasicAlert(text);
      return "";
    }
    // setCancelModalVisible(false);
    closeCancelModal();
    const cancelRequestedAt = FormatDate(new Date());
    const cancelReason = paidCancelContent;
    const status = "cancelRequest";
    const id = row.id;
    /* 결제 취소 요청 내용 DB 에 저장하기 */
    if (id) {
      const values = `cancelReason = "${cancelReason}", cancelRequestedAt = "${cancelRequestedAt}", status = "${status}"`;
      const where = `id="${id}"`;
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          query: `UPDATE creditCharge SET ${values} WHERE ${where};
    `,
        }),
      };
      await fetch(process.env.GOOGLE_CLOUD_DATABASE_CONNECT_API, requestOptions);

      setUpdateData(!updateData);
    } else {
      const text = "취소에 실패하였습니다.";
      BasicAlert(text);
    }
  };

  /* 결제 취소 요청 철회 모달 확인 버튼 클릭 시 실행 함수 */
  const handleWithDrawalModalOkButton = async () => {
    setWithdrawalModalVisible(false);

    const id = row.id;
    /* 결제 취소 요청 내용 DB 에 저장하기 */
    if (id) {
      const values = `cancelReason = "", cancelRequestedAt = "", status = "paid"`;
      const where = `id="${id}"`;
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          query: `UPDATE creditCharge SET ${values} WHERE ${where};
    `,
        }),
      };
      await fetch(process.env.GOOGLE_CLOUD_DATABASE_CONNECT_API, requestOptions);

      setUpdateData(!updateData);
    } else {
      const text = "결제 취소 철회에 실패하였습니다.";
      BasicAlert(text);
    }
  };

  return (
    <div className="flex justify-center">
      {/* <p className="text-888 font-bold text-sm">더보기</p> */}
      <button className="btn btn-grayPrimary btn-icon-text btn-sm text-sm px-2 py-1" onClick={() => setModalVisible(true)}>
        더보기 <i className="ti-arrow-circle-right m-0"></i>
      </button>
      <Modal visible={modalVisible} width="500" height="650" effect="fadeInUp" onClickAway={() => closeModal()}>
        <div className="aiso-modal">
          <div className="aiso-modal-header">
            <button className="btn btn-text-grayPrimary p-3" onClick={() => closeModal()}>
              <i className="ti-close font-bold"></i>
            </button>
          </div>
          <div className="aiso-modal-body text-center">
            <div className="flex justify-between px-3 mb-12">
              <p className="text-primary text-xl font-bold">결제 내역</p>
              <div>
                <p className="text-888 text-xs mt-2">결제일 : {row.createdAt}</p>
              </div>
            </div>
            {/* <div className="border-b border-ddd mx-3"></div> */}
            {/* 구매자 정보 */}
            <div className="px-3 pb-3 mb-2">
              <div className="w-100 flex flex-col justify-end items-end">
                <p className="w-100 flex flex-col justify-end items-end pb-1 text-555 font-bold text-lg">구매자 정보</p>
              </div>
              <div className="w-full">
                {detailList1
                  ? detailList1.map((m) => (
                      <div className="flex justify-between" key={Object.keys(m)}>
                        <p className="mb-0 text-888 font-bold text-13 number-p">{Object.keys(m)}</p>
                        <p className="mb-0 text-555 font-bold text-13 number-p">{Object.values(m)}</p>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
            {/* 결제 정보 */}
            <div className="px-3 pb-3 mb-2">
              <div className="w-100 flex flex-col justify-end items-end">
                <p className="w-100 flex flex-col justify-end items-end pb-1 text-555 font-bold text-lg">결제 정보</p>
              </div>
              <div className="w-full">
                {detailList2
                  ? detailList2.map((m) => (
                      <div className="flex justify-between" key={Object.keys(m)}>
                        <p className="mb-0 text-888 font-bold text-13 number-p">{Object.keys(m)}</p>
                        <p className="mb-0 text-555 font-bold text-13 number-p">{Object.values(m)}</p>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
            {/* 결제 수단 */}
            <div className="px-3 pb-3 mb-2">
              <div className="w-100 flex flex-col justify-end items-end">
                <p className="w-100 flex flex-col justify-end items-end pb-1 text-555 font-bold text-lg">결제 수단</p>
              </div>
              <div className="w-full">
                {detailList3
                  ? detailList3.map((m) => (
                      <div className="flex justify-between" key={Object.keys(m)}>
                        <p className="mb-0 text-888 font-bold text-13 number-p">{Object.keys(m)}</p>
                        <p className="mb-0 text-555 font-bold text-13 number-p">{Object.values(m)}</p>
                      </div>
                    ))
                  : ""}
                <div className="flex justify-end">
                  <a href={row.receiptUrl} target="_blank" rel="noreferrer" alt="">
                    영수증 확인
                  </a>
                </div>
              </div>
            </div>

            {/* 결제 취소 가능한지 체크 */}
            <ChargeCancelCheck row={row} setCancelModalVisible={setCancelModalVisible} />

            {row.status === "cancelRequest" ? (
              <div className="px-3 pb-3">
                <div className="w-100 flex flex-col justify-end items-end">
                  <button type="button" className="btn btn-grayDanger btn-sm mb-3 py-2" onClick={() => setWithdrawalModalVisible(true)}>
                    결제 취소 요청 철회
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}

            {/* 취소 모달 */}
            <Modal visible={cancelModalVisible} width="400" height="350" effect="fadeInUp" onClickAway={closeCancelModal}>
              <div className="aiso-modal">
                <div className="aiso-modal-header">
                  <button className="btn btn-text-grayPrimary p-3" onClick={closeCancelModal}>
                    <i className="ti-close font-bold"></i>
                  </button>
                </div>
                <div className="aiso-modal-body text-center">
                  <h3 className="text-xl font-bold text-danger mb-0" id="modal-title">
                    결제 취소를 요청 하시겠습니까?
                  </h3>
                  <div className="mt-2">
                    <p className="text-xs text-gray-500">결제 환불 규정에 대한 내용은 공지를 확인해 주세요.</p>
                  </div>
                  <TextField
                    id="standard-multiline-flexible"
                    label="결제 취소 사유"
                    placeholder="결제 취소 사유를 입력하세요"
                    multiline
                    maxRows={2}
                    value={paidCancelContent}
                    // onChange={handleChange}
                    onChange={(e) => setPaidCancelContent(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className="mt-4 w-full"
                  />
                </div>
                <div className="aiso-modal-footer text-center">
                  <button type="button" className="btn btn-modal-x w-1/3 py-2" onClick={() => handleCancelModalOkButton()}>
                    확인
                  </button>
                </div>
              </div>
            </Modal>

            {/* 결제 취소 요청 철회 모달 */}
            <Modal
              visible={withdrawalModalVisible}
              width="400"
              height="230"
              effect="fadeInUp"
              onClickAway={() => setWithdrawalModalVisible(false)}
            >
              <div className="aiso-modal">
                <div className="aiso-modal-header">
                  <button className="btn btn-text-grayPrimary p-3" onClick={() => setWithdrawalModalVisible(false)}>
                    <i className="ti-close font-bold"></i>
                  </button>
                </div>
                <div className="aiso-modal-body text-center">
                  <h3 className="text-xl font-bold text-danger mb-0" id="modal-title">
                    결제 취소 요청을 철회 하시겠습니까?
                  </h3>
                  <div className="mt-2">
                    <p className="text-xs text-gray-500">취소 철회 내용 확인 후 확인 버튼을 눌러주세요.</p>
                  </div>
                </div>
                <div className="aiso-modal-footer text-center">
                  <button type="button" className="btn btn-modal-x w-1/3 py-2" onClick={() => handleWithDrawalModalOkButton()}>
                    확인
                  </button>
                </div>
              </div>
            </Modal>
          </div>
          <div className="aiso-modal-footer text-center">
            <button type="button" className="btn btn-modal-o w-1/6 p-3 mx-2" onClick={() => handleModalOkButton()}>
              확인
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

/* 결제 취소 가능한지 체크  */
const ChargeCancelCheck = ({ row, setCancelModalVisible }) => {
  /* 
  1. 시간 7일이 지났는지 체크
  2. 결제 상태 체크
  3. 현재 가지고 있는 크레딧 금액 체크
  */

  const [dateCheck, setDateCheck] = useState(false);
  const [creditCheck, setCreditCheck] = useState(false);

  useEffect(() => {
    // const lastWeekDate = YesterDayDate(new Date());
    /* 시간 체크 */
    const lastWeekDate = LastWeekDate(new Date());
    const createdAt = row.createdAt.substring(0, 10);

    const dateA = new Date(lastWeekDate).getTime();
    const dateB = new Date(createdAt).getTime();

    const dateC = dateA < dateB ? true : false;

    setDateCheck(dateC);

    /* 금액 체크 */
    const docRef = projectFirestore.collection("users").doc(row.buyerEmail);
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const userCredit = doc.data().credit;
          if (userCredit >= row.credit) {
            setCreditCheck(true);
          }
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
        BasicAlert(error);
      });
  }, [row]);

  if (dateCheck && row.status === "paid" && creditCheck) {
    return (
      <div className="px-3 pb-3">
        <div className="w-100 flex flex-col justify-end items-end">
          <button type="button" className="btn btn-grayDanger btn-sm mb-3 py-2" onClick={() => setCancelModalVisible(true)}>
            결제 취소
          </button>
        </div>
      </div>
    );
  }

  return "";
};

export default ChargeList;
